export enum DialogResult {
  NotSet = 0,
  Yes = 1,
  No = 2,
  Cancel = 3,
  Ok = 4,
}
